import React from 'react';
import { Provider } from 'react-redux';
import CatalogContainer, { CatalogProps } from './catalog-container';
import { combineReducers, createStore } from 'redux';
import { organizersReducer } from '../service/organizers';
import { activitiesReducer } from '../service/activities';
import { catalogReducer } from '../service/catalog';
import { typesReducer } from '../service/types';
import kretsReducer from './krets-reducer';
import { searchReducer } from './search-reducer';
import { createRoot } from 'react-dom/client';

export default function initializeCatalog(elementOrId: HTMLElement | string, props: CatalogProps): void {
  const store = createStore(
    combineReducers({
      organizers: organizersReducer,
      activities: activitiesReducer,
      catalog: catalogReducer,
      types: typesReducer,
      selectedKretsar: kretsReducer,
      searchFilterText: searchReducer,
    })
  );
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  const root = createRoot(element);
  root.render(
    <Provider store={store}>
      <CatalogContainer {...props} />
    </Provider>
  );
}
